/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SpeedInputs */

const en_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed:`)
};

const es_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad:`)
};

const fr_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse :`)
};

const de_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschwindigkeit:`)
};

const ja_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速度:`)
};

const zh_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速度：`)
};

const ar_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السرعة:`)
};

const id_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecepatan:`)
};

const it_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocità:`)
};

const ru_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скорость:`)
};

const pt_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidade:`)
};

const ko_speed = /** @type {(inputs: SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`속도:`)
};

/**
* | output |
* | --- |
* | "Speed:" |
*
* @param {SpeedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const speed = /** @type {((inputs?: SpeedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SpeedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_speed(inputs)
	if (locale === "es") return es_speed(inputs)
	if (locale === "fr") return fr_speed(inputs)
	if (locale === "de") return de_speed(inputs)
	if (locale === "ja") return ja_speed(inputs)
	if (locale === "zh") return zh_speed(inputs)
	if (locale === "ar") return ar_speed(inputs)
	if (locale === "id") return id_speed(inputs)
	if (locale === "it") return it_speed(inputs)
	if (locale === "ru") return ru_speed(inputs)
	if (locale === "pt") return pt_speed(inputs)
	return ko_speed(inputs)
});